import React from 'react';
import Layout from '@ui-components/layout';
import DirectDebitStatus from '@ui-components/direct-debit-status';
import { getBankDays } from '@services/bank-days';
import moment from 'moment';
import './main.scss';

export default class DirectDebitStatusContainer extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.fetchWorkingDays();
        this.state = {
            datesArray: null
        };
    }

    fetchWorkingDays() {
        const { createdDate, country } = this.props;
        const datesArray = [];
        const today = moment().utc();
        getBankDays(createdDate, country).then(result => {
            for (let idx in result.data.days) {
                const stringDate = result.data.days[idx];

                const dateInfo = {
                    date: moment.utc(stringDate),
                    isCompleted: false
                };

                if (today.isAfter(dateInfo.date)) {
                    dateInfo.isCompleted = true;
                }

                datesArray.push(dateInfo);
            }

            this.setState({
                datesArray
            });
        });
    }

    render() {
        const { createdDate, country } = this.props;
        const { datesArray } = this.state;
        if (!datesArray) {
            return null;
        }
        return (
            <Layout title="Débito directo" subtitle="">
                <DirectDebitStatus createdDate={createdDate} datesArray={datesArray} country={country} />
            </Layout>
        );
    }
}
